import { User } from "../../../../../api/accessControl/User.ts";
import { OutstandingBills } from "../../components/outstandingBill/OutstandingBills.tsx";
import { BackendApi } from "../../../../../api/api.ts";
import { fetchDocumentContentBlob } from "../../../../../api/fetchDocumentContent.ts";
import { useEffect, useState } from "react";
import { OutstandingBillSummary } from "../../Stats.tsx";
import type { OutstandingBillRow } from "../../components/outstandingBill/types/outstandingBill.ts";
import { Notifications } from "../../../../../components/general/Notifications.tsx";
import { useNotifications } from "../../../../../lib/NotificationContext.tsx";

export default function OutstandingPurchaseInvoicesPage({
    currentUser,
}: {
    currentUser: User;
}) {
    const [stats, setStats] = useState<OutstandingBillSummary | null>(null);
    const [bills, setBills] = useState<OutstandingBillRow[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const api = new BackendApi(currentUser.getToken());
    const { dispatch } = useNotifications();

    async function onLoad() {
        try {
            const data = await api.Entrepreneur__outstandingBills({});
            setStats(data.summary);
            setBills(data.purchases);
        } catch (e) {
            console.error(e);
            throw e;
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        onLoad();
    }, [currentUser]);

    async function handleRowClick(bill: OutstandingBillRow) {
        try {
            const blob = await fetchDocumentContentBlob(api, 'entrepreneur/get-document-content', {
                document_id: bill.document_id,
            });
            return {
                file_name: bill.file_name,
                file_blob: blob,
                mimetype: blob.type,
            };
        } catch (e) {
            console.error(e);
            dispatch({
                title: "Fout opgetreden",
                description: "Het document kon niet worden geladen.",
                type: "error",
            });
            return null;
        }
    }

    async function handleReportIncorrect(bill: OutstandingBillRow) {
        try {
            await api.Entrepreneur__documents__reportIncorrect({ document_id: bill.document_id });
            dispatch({
                title: "Doorgegeven",
                description: "We hebben je melding ontvangen en nemen contact op indien nodig.",
                type: "success",
            });
        } catch (e) {
            console.error(e);
            dispatch({
                title: "Fout opgetreden",
                description: "De melding kon niet worden verzonden. Probeer het later opnieuw.",
                type: "error",
            });
        }
    }

    return (
        <>
            <OutstandingBills
                currentUser={currentUser}
                direction="purchase_invoice"
                stats={stats}
                bills={bills}
                isLoading={isLoading}
                onRowClick={handleRowClick}
                onReportIncorrect={handleReportIncorrect}
            />
        </>
    );
}
